import { render, staticRenderFns } from "./Mindful_Ergonomics.vue?vue&type=template&id=45cc0488"
import script from "./Mindful_Ergonomics.vue?vue&type=script&lang=js"
export * from "./Mindful_Ergonomics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports